function template(data = []) {
  return `
<cms-profile>
  <button class="cms-profile-menu-button">  
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M17 16V15C17 14.4696 16.7366 13.9609 16.2678 13.5858C15.7989 13.2107 15.163 13 14.5 13H9.5C8.83696 13 8.20107 13.2107 7.73223 13.5858C7.26339 13.9609 7 14.4696 7 15V16" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11Z" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <div class="cms-profile-menu-container" hidden>
    <div class="cms-profile-menu">
      ${data.reduce((result, item) =>
        result + `
          <div class="cms-profile-menu__item" >
            <a href="${item.href}" class="cms-profile-menu__link">
              ${item.title}
            </a>
          </div>
        `.trim(), '')}
    </div>
  </div>
</cms-profile>
`.trim();
}

export default template;
